<template>
    <div id="main">
        <page-header />
        <page-navi />
        <page-contents />
        <page-footer />
    </div>
</template>

<script>
import PageHeader from './components/PageHeader'
import PageFooter from './components/PageFooter'
import PageNavi from './components/PageNavi'
import PageContents from './pages/PageContents'

export default {
  name: 'App',
  components: {
      PageHeader,
      PageFooter,
      PageNavi,
      PageContents
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
#main {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/App.vue